import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section id="home" style={{ paddingTop: '160px', minHeight: '100vh', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', backgroundColor: 'var(--bg-main)' }}>
      {/* Ambient Lighting */}
      <div className="ambient-light" style={{ top: '-20%', left: '-10%', opacity: 0.3 }}></div>
      <div className="ambient-light ambient-light-silver" style={{ bottom: '-20%', right: '-10%', opacity: 0.2 }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 10 }}>
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-12 mb-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: [0.23, 1, 0.32, 1] }}
            >
              <h1 style={{ 
                fontSize: 'clamp(3rem, 10vw, 12vw)', 
                fontWeight: 900, 
                lineHeight: 0.85, 
                letterSpacing: '-0.05em', 
                textTransform: 'uppercase', 
                color: 'var(--text-main)',
                marginBottom: '-2vw'
              }}>
                Erenis<span style={{ display: 'block', WebkitTextStroke: '1px var(--section-title-stroke)', color: 'transparent' }}>Otomotiv</span>
              </h1>
            </motion.div>
          </div>

          <div className="lg:col-span-5" style={{ position: 'relative', zIndex: 30 }}>
            <motion.p 
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.2, ease: [0.23, 1, 0.32, 1] }}
              className="text-lg text-text-muted mb-12"
              style={{ fontWeight: 300, lineHeight: 1.7, maxWidth: '24rem' }}
            >
              Geleceğin otomobil deneyimini bugünden keşfedin. Seçkin araç koleksiyonumuzla prestijin zirvesine yolculuk yapın.
            </motion.p>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.4, ease: [0.23, 1, 0.32, 1] }}
              className="flex items-center gap-10"
            >
              <Link to="/araclar" className="text-sm font-bold text-primary" style={{ letterSpacing: '0.2em', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '1rem' }}>
                Koleksiyonu Keşfet
                <div style={{ width: '48px', height: '1px', background: 'var(--primary)', transition: 'width 0.5s' }}></div>
              </Link>
            </motion.div>
          </div>

          <div className="lg:col-span-7" style={{ position: 'relative' }}>
            <motion.div 
              initial={{ opacity: 0, scale: 1.1, x: 50 }}
              animate={{ opacity: 1, scale: 1, x: 0 }}
              transition={{ duration: 1.5, ease: [0.23, 1, 0.32, 1] }}
            >
              <div style={{ aspectRatio: '16/10', overflow: 'hidden', borderRadius: '4px', border: '1px solid var(--card-border)' }}>
                <img 
                  src="/images/bmw_main.png" 
                  alt="Luxury Car" 
                  className="w-full object-cover"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', transform: 'scale(1.05)', transition: 'transform 3s ease' }}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
